import { Component, ViewChild, ElementRef } from '@angular/core';
import { Platform, NavParams, ModalController, ActionSheet, ActionSheetController, App, NavController, LoadingController, ToastController } from 'ionic-angular';
import { ResultProvider } from '../../../providers/result/result';
import { DeviceMotion, DeviceMotionAccelerationData } from '@ionic-native/device-motion';
import { AudioSystemProvider } from '../../../providers/audio-system/audio-system';
import { TranslateService } from '@ngx-translate/core';
import { UserProvider } from '../../../providers/user/user';
import { Storage } from '@ionic/storage';
import { StrackerProvider, TrackerModel } from '../../../providers/stracker/stracker';
import { SessionProvider } from '../../../providers/session/session';
import { Device } from '@ionic-native/device';
import { Diagnostic } from '@ionic-native/diagnostic';
import { ConfigProvider } from '../../../providers/config/config';
import { AndroidPermissions } from '@ionic-native/android-permissions';

declare var google;

/**
 * THIS COMPONENT IS DEPRECATED AND HAS TO BE REMOVED.
 */

@Component({
    selector: 'permission-page',
    templateUrl: 'permission.html',
})
export class PermissionPage {

    appName: string = "";
    appLogo: string = "";
    background: string = "";
    os: string = "";

    constructor(
        public platform: Platform,
        private navParams: NavParams,
        private app: App,
        private config: ConfigProvider,
        private androidPermissions: AndroidPermissions,
        private nav: NavController) {
            this.os = this.navParams.get('os');
    }

    doneIOS() {
        (this.app.getRootNav() as NavController).pop();
    }

    doneANDROID() {
        this.checkBackgroundPermission();
        (this.app.getRootNav() as NavController).pop();
    }

    cancel() {
        this.nav.pop().then(() => this.nav.pop());
    }

    async ionViewDidLoad() {
        this.appName = (await this.config.config).appId;
        this.appLogo = "/assets/imgs/tutorial/" + this.appName + ".png";
        this.background = "background: url('" + this.appLogo + "') 50% 0 / 90px repeat;"
        document.getElementsByClassName('pattern-bg').item(0).setAttribute('style', this.background);
        document.getElementsByClassName('pattern-bg').item(1).setAttribute('style', this.background);

        console.log('this.background: ', this.background);
    }

    private async checkBackgroundPermission() {
        try {
            console.log('this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION: ', this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
            const result = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
            if (!result || result.hasPermission === false) {
                this.requestPermissions();
            }
        } catch (error) {
            this.requestPermissions();
        }
    }

    private async requestPermissions() {
        try {
            console.log('this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION: ', this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
            const data = await this.androidPermissions.requestPermissions([
                this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION,
                this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION,
                this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
                this.androidPermissions.PERMISSION.ACTIVITY_RECOGNITION,
                this.androidPermissions.PERMISSION.FOREGROUND_SERVICE
            ]);
            if (!data.hasPermission) {
                throw new Error('No permission');
            }
        } catch (error) {
            console.log('We need background location access in order to continue.');

        }
    }
}





// WEBPACK FOOTER //
// /src/tracker/sencha-tracker/tutorial-permission/permission.ts